module.exports = __webpack_public_path__ + "img/youtube-icon.dcf7494e.svg";